import { PrimaryCta } from '@sleepstation/components'
import { defaultDarkerTheme } from '@sleepstation/themes-public-site'
import React from 'react'
import { useLoaderData } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import PortalPage from '../pages/PortalPage'
import LinkPreview from '../pages/portal/PortalDashboard/LinkPreview'
import KnowledgeBasePreview from '../pages/portal/shared/KnowledgeBasePreview'
import BreakoutModuleNarrow from '../shared/breakoutModules/BreakoutModuleNarrow'
import BreakoutModuleWide from '../shared/breakoutModules/BreakoutModuleWide'
import StarscapeCallToActionBreakoutModule from '../shared/breakoutModules/StarscapeCallToActionBreakoutModule'
import LeftAlignedSimpleHero from '../shared/heroes/LeftAlignedSimpleHero'
import PortalMailingListSignup from '../shared/portal/PortalMailingListSignup'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalDashboardModule = () => {
  const data = useLoaderData()
  const {
    page: { content },
  } = data

  return (
    <PortalPage data={data} footerMargin={0}>
      <LeftAlignedSimpleHero {...content.hero} hasBorder />
      <BreakoutModuleWide
        hasGradient
        hasBottomBorder
        paddingV={[
          [1, 0.5],
          [1, 2],
          [1, 2],
          [0, 2.5],
        ]}
        marginV={[
          [0.5, 0],
          [2, 0],
        ]}
      >
        <KnowledgeBasePreview {...content.knowledgeBasePreview} />
      </BreakoutModuleWide>
      <BreakoutModuleWide
        paddingV={[
          [1, 0.5],
          [1, 1],
          [1, 1],
          [1, 1.5],
        ]}
        marginV={[
          [0.5, 1.5],
          [2, 0.5],
        ]}
      >
        <LinkPreview {...content.linkPreview} />
      </BreakoutModuleWide>
      <ThemeProvider theme={defaultDarkerTheme}>
        <StarscapeCallToActionBreakoutModule>
          <PrimaryCta {...content.cta} />
        </StarscapeCallToActionBreakoutModule>
      </ThemeProvider>
      <BreakoutModuleNarrow
        hasBottomBorder={false}
        hasGradient={false}
        marginV={[[1, 0]]}
        paddingV={[
          [1, 2],
          [2, 3],
        ]}
      >
        <PortalMailingListSignup />
      </BreakoutModuleNarrow>
    </PortalPage>
  )
}

export default PortalDashboardModule
